<template>
  <div>
    <table-view
      ref="tableList"
      :tableModel="tableModel"
      :tableData="tableData"
      :searchModel="searchModel"
      :pages="pages"
      @searchChange="handleSearchChange"
      @pageChange="handlePageChange"
      @clickClearBtn="handleClickClearBtn"
      @changeTitleActionBtn="handleTitleActionBtn"
      tableCardTitle="COUNTRY RISK REPORTS LIST"
      :right-btn-options="{ text: 'Add', isHavePermission: true }"
    >
      <template v-slot:vagueSearch>
        <div style="display: flex; gap: 30px; align-items: center; width: calc(400% - 90px); margin-left: -100%">
          <div style="width: 260px">
            <el-form-item label="Reporting Year" style="margin-bottom: 0">
              <el-date-picker
                v-model="searchReportYear"
                type="year"
                placeholder="Please select reporting year"                style="width: 100%"
                format="yyyy"
                value-format="yyyy"
                clearable
              />
            </el-form-item>
          </div>
          <div style="width: 300px">
            <el-form-item label="Country" style="margin-bottom: 0">
              <el-select
                v-model="searchCountry"
                placeholder="Please select country"                style="width: 100%"
                filterable
                clearable
              >
                <el-option
                  v-for="item in countryOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </div>
        </div>
      </template>
      <template v-slot:reportStatus="{ tableRow }">
        <span>
          {{
            tableRow.row.reportStatus === 1
              ? 'Complete'
              : tableRow.row.reportStatus === 2
              ? 'Fail'
              : tableRow.row.reportStatus === 3
              ? 'In Progress'
              : '-'
          }}
        </span>
      </template>
      <template v-slot:country="{ tableRow }">
        <span>
          {{ getCountryName(tableRow.row.country) }}
        </span>
      </template>
      <template v-slot:reportName="{ tableRow }">
        <div>
          <div
            v-for="(file, index) in getReportFiles(tableRow.row.files)"
            :key="index"
            style="margin-bottom: 4px"
          >
            <el-button
              type="text"
              size="mini"
              style="color: #1890ff; padding: 0; text-align: left"
              :loading="file.downloadLoading"
              :title="file.fileName"
              @click="handleDownloadReportFile(file, tableRow.$index, index)"
            >
              {{ formatFileName(file.fileName) }}
            </el-button>
          </div>
        </div>
      </template>
      <template v-slot:action="{ tableRow }">
        <div style="white-space: nowrap">
          <el-button
            v-if="tableRow.row.reportStatus === 1"
            type="primary"
            size="mini"
            round
            style="background: #1890ff; border: none"
            @click="$router.push('/ai/country-risk-report/' + tableRow.row.id)"
          >
            View
          </el-button>
        </div>
      </template>
    </table-view>

    <!-- Add 弹窗 -->
    <el-dialog
      :visible.sync="addVisible"
      title="Add"
      width="462px"
      @close="handleAddCancel"
      :close-on-click-modal="false"
    >
      <el-card shadow="never">
        <el-form :model="addForm" ref="addForm" label-position="top">
          <el-form-item label="Reporting Year" prop="reportingYear">
            <el-date-picker
              v-model="addForm.reportingYear"
              type="year"
              placeholder="Please select reporting year"
              style="width: 100%"
              format="yyyy"
              value-format="yyyy"
            ></el-date-picker>
          </el-form-item>

          <el-form-item label="Country" prop="country">
            <el-select
              v-model="addForm.country"
              placeholder="Please select country"
              style="width: 100%"
              filterable
              remote
              :remote-method="remoteSearchCountry"
              :loading="countryLoading"
              reserve-keyword
              clearable
            >
              <el-option
                v-for="item in filteredCountryOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Upload Documents">
            <el-upload
              ref="upload"
              :file-list="fileList"
              :http-request="customUpload"
              :before-upload="beforeUpload"
              :on-success="handleUploadSuccess"
              :on-error="handleUploadError"
              :on-remove="handleRemove"
              :limit="5"
              :on-exceed="handleExceed"
              action="#"
              drag
              multiple
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                Drop file here or
                <em>click to upload</em>
              </div>
              <div class="el-upload__tip" slot="tip">Support up to 5 files</div>
            </el-upload>
          </el-form-item>
        </el-form>
      </el-card>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleAddCancel">Cancel</el-button>
        <el-button
          type="primary"
          :loading="addLoading"
          @click="handleAddSubmit"
        >
          Submit
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getCountryRiskReportList,
  downloadFile,
  aiUploadFile,
  saveRiskReport,
} from './api'
import { getSelectList } from '@/api'

export default {
  data() {
    return {
      addVisible: false,
      addLoading: false,
      addForm: {
        reportingYear: '',
        country: '',
        attachments: [],
      },
      fileList: [],
      countryOptions: [],
      filteredCountryOptions: [],
      countryLoading: false,
      searchReportYear: '',
      searchCountry: '',
      searchModel: [
        {
          label: '',
          type: 'input',
          key: '_placeholder',
          style: { display: 'none' },
        },
      ],
      tableData: [],
      pages: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
    }
  },
  computed: {
    tableModel() {
      return [
        {
          label: 'Reporting Year',
          prop: 'reportYear',
        },
        {
          label: 'Country',
          prop: 'country',
          slotName: 'country',
        },
        {
          label: 'Original Country Report',
          prop: 'reportName',
          slotName: 'reportName',
        },
        {
          label: 'Submitted By',
          prop: 'submittedBy',
        },
        {
          label: 'Create Time',
          prop: 'createTime',
        },
        {
          label: 'Status',
          prop: 'reportStatus',
          slotName: 'reportStatus',
        },
        {
          label: 'Action',
          slotName: 'action',
          width: '120px',
        },
      ]
    },
  },
  created() {
    this._getTableData()
    this._getSelectList()
  },
  methods: {
    getCountryName(countryId) {
      const country = this.countryOptions.find(item => item.id === countryId)
      return country ? country.name : countryId || '-'
    },
    formatFileName(fileName) {
      if (!fileName || typeof fileName !== 'string') {
        return fileName
      }

      // 如果文件名长度小于等于22个字符（10+2+10），直接返回
      if (fileName.length <= 22) {
        return fileName
      }

      // 找到最后一个点的位置来分离文件名和扩展名
      const lastDotIndex = fileName.lastIndexOf('.')

      if (lastDotIndex === -1) {
        // 没有扩展名的情况
        return (
          fileName.substring(0, 10) +
          '...' +
          fileName.substring(fileName.length - 10)
        )
      } else {
        // 有扩展名的情况
        const nameWithoutExt = fileName.substring(0, lastDotIndex)
        const extension = fileName.substring(lastDotIndex)

        if (nameWithoutExt.length <= 20) {
          // 如果不包括扩展名的部分长度小于等于20，直接返回
          return fileName
        } else {
          // 省略中间部分
          return (
            nameWithoutExt.substring(0, 10) +
            '...' +
            nameWithoutExt.substring(nameWithoutExt.length - 10) +
            extension
          )
        }
      }
    },
    getReportFiles(files) {
      // 如果 files 是数组，直接返回
      if (Array.isArray(files)) {
        return files.map(file => ({
          ...file,
          downloadLoading: false,
        }))
      }
      // 如果 files 是字符串，尝试解析为 JSON
      if (typeof files === 'string') {
        try {
          const parsed = JSON.parse(files)
          if (Array.isArray(parsed)) {
            return parsed.map(file => ({
              ...file,
              downloadLoading: false,
            }))
          }
        } catch (e) {
          // 解析失败，当作普通字符串处理
          return [
            {
              fileName: files,
              fileUrl: '',
              downloadLoading: false,
            },
          ]
        }
      }
      // 其他情况返回空数组
      return []
    },
    async handleDownloadReportFile(file, rowIndex, fileIndex) {
      if (!file.fileUrl) {
        this.$message.error('File URL not found')
        return
      }

      // 直接操作原始数据中的loading状态
      if (
        this.tableData[rowIndex].files &&
        Array.isArray(this.tableData[rowIndex].files)
      ) {
        this.$set(
          this.tableData[rowIndex].files[fileIndex],
          'downloadLoading',
          true,
        )
      }

      try {
        await downloadFile({ url: file.fileUrl, fileName: file.fileName })
        this.$message.success('Download started')
      } catch (err) {
        console.error(err)
        this.$message.error('Download failed')
      } finally {
        if (
          this.tableData[rowIndex].files &&
          Array.isArray(this.tableData[rowIndex].files)
        ) {
          this.$set(
            this.tableData[rowIndex].files[fileIndex],
            'downloadLoading',
            false,
          )
        }
      }
    },
    async _getSelectList() {
      const data = await getSelectList({ typeMark: 'Country' })
      this.countryOptions = data || []
      this.filteredCountryOptions = data || [] // 初始显示所有选项
      // this.searchModel[1].selectList = data || []
    },
    async _getTableData(params = {}) {
      // 只添加必要的分页参数
      params.current = params.current || this.pages.current
      params.pageSize = this.pages.pageSize

      try {
        const { data, page } = await getCountryRiskReportList(params)
        // 处理数据，为文件添加loading状态
        this.tableData = (data || []).map(row => {
          if (row.files && Array.isArray(row.files)) {
            row.files = row.files.map(file => ({
              ...file,
              downloadLoading: false,
            }))
          }
          return row
        })
        this.pages.total = page.total || 0
      } catch (err) {
        console.error(err)
      }
    },
    handlePageChange(page) {
      console.log(page)

      // 处理page参数，可能是数字或对象
      const currentPage =
        typeof page === 'object'
          ? page.current || page.currentPage || page.page
          : page

      this.pages.current = currentPage
      const params = this.$refs.tableList.getSearchData()
      delete params.size
      params.current = currentPage
      this._getTableData(params)
    },
    handleSearchChange(params) {
      // 删除不需要的参数
      delete params.size
      // 添加自定义搜索参数
      if (this.searchReportYear) {
        params.reportYear = this.searchReportYear
      }
      if (this.searchCountry) {
        params.country = this.searchCountry
      }
      params.current = 1
      this._getTableData(params)
    },
    handleClickClearBtn() {
      // 清除所有搜索条件
      this.searchReportYear = ''
      this.searchCountry = ''
    },
    async handleDownloadFile(tableRow) {
      const $index = tableRow.$index
      this.$set(this.tableData[$index], 'downloadLoading', true)
      try {
        const fileUrl = tableRow.row.reportUrl
        if (!fileUrl) {
          this.$message.error('File URL not found')
          return
        }
        await downloadFile({ url: fileUrl })
        this.$message.success('Download started')
      } catch (err) {
        console.error(err)
        this.$message.error('Download failed')
      } finally {
        this.$set(this.tableData[$index], 'downloadLoading', false)
      }
    },
    handleTitleActionBtn() {
      this.addForm = {
        reportingYear: '',
        country: '',
        attachments: [],
      }
      this.fileList = []
      this.addVisible = true
    },
    handleAddCancel() {
      this.addVisible = false
    },
    async handleAddSubmit() {
      if (!this.addForm.reportingYear) {
        this.$message.error('Please select reporting year')
        return
      }
      if (!this.addForm.country) {
        this.$message.error('Please select country')
        return
      }
      if (!this.addForm.attachments || this.addForm.attachments.length === 0) {
        this.$message.error('Please upload at least one document')
        return
      }

      this.addLoading = true
      try {
        // 准备接口参数，确保 files 数组包含正确的文件信息
        const params = {
          reportYear: this.addForm.reportingYear,
          country: this.addForm.country,
          files: this.addForm.attachments.map(file => ({
            fileName: file.name,
            fileUrl: file.url,
          })),
        }

        console.log('Submitting params:', params)
        await saveRiskReport(params)
        this.$message.success('Country risk report added successfully!')
        this.addVisible = false
        this._getTableData()
      } catch (err) {
        console.error(err)
        this.$message.error('Failed to add country risk report')
      } finally {
        this.addLoading = false
      }
    },
    beforeUpload(file) {
      // 检查文件类型
      const validTypes = [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      ]
      if (!validTypes.includes(file.type)) {
        this.$message.error('Only PDF, Word, and Excel files are allowed!')
        return false
      }

      // 检查文件大小 (1024MB = 1GB)
      const isLt1G = file.size / 1024 / 1024 < 1024
      if (!isLt1G) {
        this.$message.error('File size cannot exceed 1GB!')
        return false
      }

      return true
    },
    async customUpload(option) {
      try {
        const formData = new FormData()
        formData.append('file', option.file)
        const response = await aiUploadFile(formData)

        // 确保响应包含文件 URL
        if (response) {
          this.$message.success('File uploaded successfully!')
          option.onSuccess(response, option.file)
        } else {
          throw new Error('Upload response is empty')
        }
      } catch (error) {
        console.error('Upload error:', error)
        this.$message.error('File upload failed!')
        option.onError(error)
      }
    },
    handleUploadSuccess(response, file, fileList) {
      console.log('Upload success - response:', response)
      console.log('Upload success - file:', file)
      console.log('Upload success - fileList:', fileList)

      // 重建 attachments 数组，保持已有的有效数据
      const newAttachments = []

      fileList.forEach(fileItem => {
        let url = null

        // 优先使用 fileItem.response，如果没有且当前文件是刚上传的，使用 response
        if (fileItem.response) {
          url = fileItem.response
        } else if (fileItem.raw === file && response) {
          url = response
          // 同时更新 fileItem.response 以便下次使用
          fileItem.response = response
        } else if (fileItem.url) {
          url = fileItem.url
        }

        // 如果还是没有找到 URL，尝试从现有的 attachments 中查找
        if (!url) {
          const existingAttachment = this.addForm.attachments.find(
            att => att.name === fileItem.name,
          )
          if (existingAttachment) {
            url = existingAttachment.url
          }
        }

        console.log('Processing file:', fileItem.name, 'URL found:', url)

        if (url) {
          newAttachments.push({
            name: fileItem.name,
            url: url,
          })
        }
      })

      this.addForm.attachments = newAttachments
      this.fileList = fileList
      console.log('Final attachments:', this.addForm.attachments)
    },
    handleUploadError(err) {
      console.error('Upload error:', err)
      this.$message.error('File upload failed!')
    },
    handleRemove(file, fileList) {
      console.log('Remove file:', file)
      console.log('Remaining fileList:', fileList)

      // 使用与 handleUploadSuccess 相同的逻辑重建 attachments 数组
      const newAttachments = []

      fileList.forEach(fileItem => {
        let url = null

        // 检查不同可能的 URL 来源
        if (fileItem.response) {
          url = fileItem.response
        } else if (fileItem.url) {
          url = fileItem.url
        }

        // 如果还是没有找到 URL，尝试从现有的 attachments 中查找
        if (!url) {
          const existingAttachment = this.addForm.attachments.find(
            att => att.name === fileItem.name,
          )
          if (existingAttachment) {
            url = existingAttachment.url
          }
        }

        console.log(
          'Processing remaining file:',
          fileItem.name,
          'URL found:',
          url,
        )

        if (url) {
          newAttachments.push({
            name: fileItem.name,
            url: url,
          })
        }
      })

      this.addForm.attachments = newAttachments
      this.fileList = fileList
      console.log('After remove, attachments:', this.addForm.attachments)
    },
    handleExceed() {
      this.$message.warning('You can only upload up to 5 files!')
    },
    remoteSearchCountry(query) {
      if (query !== '') {
        this.countryLoading = true
        setTimeout(() => {
          this.countryLoading = false
          this.filteredCountryOptions = this.countryOptions.filter(item => {
            return item.name.toLowerCase().indexOf(query.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.filteredCountryOptions = this.countryOptions
      }
    },
  },
}
</script>
